<style lang="less" scoped>
.chatBox {
  width: 1240px;
  height: calc(100vh - 150px);
  min-height: 320px;
  margin: 20px auto;
  display: flex;
  border-radius: @border-radius-base;
  background-color: @white;
  .left {
    padding: 20px 0;
    width: 250px;
    min-width: 250px;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    .loading {
      position: absolute;
      top: 50%;
      left: 50%;
    }
    .group {
      padding: 15px 20px;
      border-bottom: dotted 1px #eee;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
    }
    .group:hover {
      color: @primary-color;
    }
    .active {
      background-color: #f7f5f0;
      color: @primary-color;
    }
  }
  .mid {
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    width: 70px;
    align-items: center;
    background-color: #f7f5f0;
    padding: 20px 15px;
    .btn {
      width: 100%;
      margin-top: 10px;
      cursor: pointer;
    }
    .btn:hover {
      box-shadow: 0 0 5px #999;
    }
    .user-photo {
      width: 50px;
      height: 50px;
      margin-bottom: 30px;
      border-radius: 50%;
    }
  }
  .right {
    flex-grow: 1;
    overflow: auto;
  }
}
</style>
<template>
  <div class="chatBox">
    <div class="left">
      <a-spin class="loading" v-show="false" />
      <div :id="'nav' + index" v-for="(group,index) in classData" :key="group.groupTag.toString()"
           :class="{group:true,active:group.groupTag===currentGroupId}"
           @click="changeGroup(group.groupTag,group.id)">{{group.className}}</div>
    </div>
    <div class="mid">
      <!-- <img v-if="shareData.classInfo.photo!=null" group="user-photo" :src="resBasePath+'/'+shareData.classInfo.photo"/> -->
      <router-link :to="{ name: 'ChatClass',params:{groupid:currentGroupId}}">
        <img class="btn" :src="`imgs/${currentModule==='ChatClass'?'1-12.png':'1-11.png'}`" />
      </router-link>
      <router-link :to="{ name: 'NoticeClass',params:{groupid:currentGroupId}}">
        <img class="btn" :src="`imgs/${currentModule==='NoticeClass'?'2-12.png':'2-11.png'}`" />
      </router-link>
      <router-link :to="{ name: 'MemberClass',params:{groupid:currentGroupId}}">
        <img class="btn" :src="`imgs/${currentModule==='MemberClass'?'3-12.png':'3-11.png'}`" />
      </router-link>
      <router-link :to="{ name: 'ClassInfoClass',params:{groupid:currentGroupId}}">
        <img class="btn" :src="`imgs/${currentModule==='ClassInfoClass'?'4-02.png':'4-01.png'}`" />
      </router-link>
    </div>
    <div class="right">
      <router-view />
    </div>
    <!-- <iframe :src="url" frameborder="0" id="iframId" group="iframe"></iframe> -->
  </div>
</template>

<script>
import WebIM from 'utils/WebIM';
import shareState from 'utils/shareState.js';
// className: "周老师的班级"
// groupTag: "132311627661314"
// id: 909
// intro: "zxc"
// studentCount: 4
// teaId: "b36547f3b26f4174aa84c0850d0e3086"
// teaName: "周老师"
export default {
  name: 'class',
  components: {},
  watch: {
    $route() {
      this.currentModule = this.$route.name;
      this.getClassInfoById(this.currentGroupId);
    },
    classData: {
      handler: function (val, oldval) {
        this.groupLists = val;
      },
    },
  },
  data() {
    return {
      loading: false,
      resBasePath: this.$resBasePath,
      shareData: shareState.state,
      currentModule: 'ChatClass',
      currentGroupId: '',
      classData: [],
      // url: 'myClass/index.html?userId=' + this.$getUserInfo().id
    };
  },
  beforeMount() {
    this.getCurrentGroup();
    this.getCurrentModule();
   // this.getImInfo();
    this.getHistoryMsg();
  },
  mounted() {
    this.classData = localStorage.getItem('user_info').class;
    this.getMyClassNum();
  },
  methods: {
    changeModule(module) {
      this.currentModule = module;
    },
    getCurrentGroup() {
      this.currentGroupId = this.$route.params.groupid;
      if (this.currentGroupId) {
        this.getClassInfoById(this.currentGroupId);
        return;
      }
      if (this.classData && this.classData.length > 0) this.currentGroupId = this.classData[0].groupid;
      this.getClassInfoById(this.currentGroupId);
    },
    getCurrentModule() {
      this.currentModule = this.$route.name;
      if (this.currentModule === 'Class') this.$router.push({ path: `class/chat/${this.currentGroupId}` });
    },
    getImInfo() {
      // 获取用户IM注册信息
      if (this.shareData.imUserInfo) {
        this.loginWebIm(this.shareData.imUserInfo);
        return;
      }
      this.$fetch({
        url: this.$httpConfig.getUserLoginToken,
      })
        .loading(() => (this.loading = true))
        .done((res) => {
          if (res && res.success && res.resultData) {
            shareState.setImUserInfo({
              access_token: res.resultData.access_token,
              expires_in: res.resultData.expires_in,
              user: res.resultData.user,
            });
           // this.loginWebIm();
          }
        });
    },
    updateMessages(message, msgType) {
      const stu = this.shareData.myClassStudents.find((student) => student.id === message.from);
      const fromUserName = stu?.userName || message.from;
      const fromUserPhoto = stu?.photo ? this.$userINfoBasePath + '/' + stu?.photo : 'imgs/logo.png';
      const receivedMsg = Object.assign(message, {
        msg: msgType === 'txt' ? message.sourceMsg : message.url,
        fromUserName,
        fromUserPhoto,
        chatType: 'groupChat',
        msgType: msgType,
        bySelf: false,
        status: 'received',
      });
      shareState.setMsgList(receivedMsg);
    },
    loginWebIm() {
      const options = {
        apiUrl: WebIM.config.apiURL,
        user: this.shareData.imUserInfo.user.username,
        accessToken: this.shareData.imUserInfo.access_token,
        appKey: WebIM.config.appkey,
      };
      const vm = this;
      WebIM.conn.open(options);
      WebIM.conn.listen({
        onOpened: function (message) {
          // 连接成功回调
          vm.loading = false;
          // vm.getGroupList()
        },
        onTextMessage: function (message) {
          // 收到文本消息
          vm.updateMessages(message, 'txt');
          // console.log('收到文本消息', message.time.length, message)
        },
        onPictureMessage: function (message) {
          // 接收图片消息
          vm.updateMessages(message, 'img');
        },
        onAudioMessage: function (message) {
          // 收到音频消息
          console.log('收到音频消息', message);
          vm.updateMessages(message, 'audio');
        },
        onFileMessage: function (message) {
          // 收到文件消息
          console.log('收到文件消息', message);
          vm.updateMessages(message, 'file');
        },
        onVideoMessage: function (message) {
          // 收到视频消息
          console.log('收到视频消息', message);
          vm.updateMessages(message, 'video');
        },
        onRecallMessage: function (message) {
          // 收到消息撤回回执
          console.log('收到消息撤回回执', message);
        },
      });
    },
    getGroupList() {
      var options = {
        success: (res) => {
          // console.log('getGroupList', res)
          // shareState.setImGroupList(res.data)
          this.currentGroupId = res.data.length > 0 && res.data[0].groupid;
          this.$router.push({ path: `/class/chat/${this.currentGroupId}` });
        },
        error: (e) => {
          this.$message.error('获取群组失败！');
          this.getGroupList();
        },
      };
      WebIM.conn.getGroup(options);
    },
    changeGroup(groupid, id) {
      // console.log(groupid, id);
      // console.log(this.currentGroupId);
      localStorage.setItem('classID', id);
      this.currentGroupId = groupid;
      const reg = /\/\d+$/;
      const cPath = this.$route.path.replace(reg, '');
      const cPath1 = cPath.toString().replace('/undefined', '');
      this.$router.push({ path: `${cPath1}/${groupid}` });
    },
    getClassInfoById() {
      const _this = this;
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/class/common/getClassInfoById',
          body: { id: localStorage.getItem('classID') },
        })
        .loading(
          () => (_this.loading = true),
          () => (_this.loading = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode == 0) {
            shareState.setMyClassStudents(res.resultData.students); // 班级成员
            shareState.setClassInfo(res.resultData);
            shareState.setIsStudentJoin(res.resultData.isStudentJoin);
          }
        });
    },
    getHistoryMsg() {
      if (!localStorage.getItem('syzgImMsg')) return;
      const historyMsgs = JSON.parse(localStorage.getItem('syzgImMsg'));
      shareState.setMsgList(historyMsgs, true);
      if (!historyMsgs) return;
      this.$store.commit('setMsgList', historyMsgs);
    },
    getMyClassNum() {
      // 获取我的班级列表
      const _this = this;
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/class/common/getMyClassInfo',
          body: { userId: _this.$getUserInfo().id },
        })
        .loading(
          () => (_this.loading = true),
          () => (_this.loading = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.classData = res.resultData;
            // localStorage.setItem('newClassInfo',JSON.stringify(this.classData))
            shareState.setImGroupList(_this.classData);
            // console.log('获取我的班级列表添加到聊天页面', _this.classData)
          }
        });
    },
    getV2MyClass () {
      // 根据用户id获取我的班级--重新拆分接口，减少原大接口耗时
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/v2/getV2MyClass',
        body: { userId: _this.$getUserInfo().id }
      })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            // _this.classData = res.resultData;
            // shareState.setClassInfo(_this.classData)
            console.log('getV2MyClass')
            console.log(res)
          }
        })
    }
  },
  directives: {
    trigger: {
      inserted(el, binging) {
        el.id == 'nav0' ? el.click() : null;
      },
    },
  },
};
</script>
